import {useEffect, useState} from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Appbar from "../components/layout/appbar";
import Sidebar from '../components/layout/sidebar';
import {useLocation} from "react-router-dom";
import CustomModalV2 from '../components/ui/custom-dialog.jsx';
import AuthService from '../services/auth';
import UserProfileDialog from '../../plugins/ProfilePlugin/components/user/user-profile.dialog';
import useUserProfile from '../../plugins/ProfilePlugin/hooks/useUserProfile.js';
import CustomModal from '../components/ui/custom-modal.component.jsx';
import { useRBAC, useRBACStore } from '../../plugins/RBACPlugin/index.js';
import { useSnackbar } from 'notistack';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const MainLayoutScreen = ({children}) => {
  const theme = useTheme();
  const location = useLocation();
  

  let isAuthenticated = AuthService.isUserLoggedIn();

  const [open, setOpen] = useState(true);
  // const [selectedProfile, setSelectedProfile] = useState("");
  // const [openModal, setOpenModal] = useState(false);

  // const { enqueueSnackbar } = useSnackbar();

  const profile_uid = localStorage.getItem("profile_uid")
  // const {setRole, setPermissions} = useRBACStore();
  // const {getProfilePermissions, profilePermissions, errorGetProfilePermissions} = useRBAC()

  // useEffect(() => {
  //     if (profilePermissions.length > 0) {
  //         let allowed_permissions = extractEnabledPermissions(profilePermissions)
  //         setPermissions(allowed_permissions)
  //         window.location.reload();
  //     }
  // }, [JSON.stringify(profilePermissions)])

  // useEffect(() => {
  //     if (errorGetProfilePermissions) {
  //         let err_msg = errorGetProfilePermissions?.error || errorGetProfilePermissions?.message || "Something went wrong."
  //         enqueueSnackbar(err_msg, {
  //             variant: "error",
  //             autoHideDuration: 3000
  //         });
  //     }
  // }, [JSON.stringify(errorGetProfilePermissions)])
  
  // const handleCloseModal = () => setOpenModal(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  }

  const handleDrawerClose = () => {
    setOpen(false);
  }

  // const handleSelectProfile = (profile) => {
  //   setSelectedProfile(profile)
  //   console.log('selected profile uid', profile)
  //   localStorage.setItem("profile_uid", profile.profile_uid);
  //   setRole(profile.profile_type)

  //   // get profile permissions
  //   getProfilePermissions(profile.profile_uid);
  // }

  // console.log('get selected profile ', selectedProfile)

  // useEffect(()=>{
  //   if(!profile_uid) setOpenModal(true)
  // },[])


  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <Appbar open={open} handleDrawerOpen={handleDrawerOpen} />
      <Sidebar open={open} handleDrawerClose={handleDrawerClose} theme={theme} />

      <Box component="main" sx={{flexGrow: 1, p: 3}}>
        <DrawerHeader />
        {children}
      </Box>
      
      {/* <CustomModal
          open={openModal}
          handleClose={handleCloseModal}
          title="Select Profile"
      >
        <UserProfileDialog handleSelectProfile={handleSelectProfile}/>
      </CustomModal> */}
    </Box>
  )
}

export default MainLayoutScreen
